import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { MileageComponent } from 'src/app/_components/remote-action-step/mileage/mileage.component';

@Injectable()
export class MilageRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep
{
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return MileageComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    return true;
  }
}
